/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedbackText } from './taskFeedbackText';
import type { TaskFeedbackHighlighting } from './taskFeedbackHighlighting';

/**
 * Simplified feedback for a task submission
 */
export interface TaskFeedback {
  /** The feedback text for the student */
  text?: TaskFeedbackText;
  /** Optional highlighting of text segments by dimension */
  highlighting?: TaskFeedbackHighlighting;
}
